import { render, staticRenderFns } from "./dcPxCatList.vue?vue&type=template&id=12b222ac&scoped=true&"
import script from "./dcPxCatList.vue?vue&type=script&lang=js&"
export * from "./dcPxCatList.vue?vue&type=script&lang=js&"
import style0 from "./dcPxCatList.vue?vue&type=style&index=0&id=12b222ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b222ac",
  null
  
)

export default component.exports